export default {
  "errors.auth.invalidPasswordOrEmail": {
    en: "Wrong email or password",
    es: "Email o contraseña erróneo.",
  },
  "errors.auth.blockedUser": {
    en: "User is blocked",
    es: "El usuario está bloqueado.",
  },
  "errors.auth.failedAttempts": {
    en: "Login failed. Try again __$1__",
    es: "Login fallido. Inténtalo de nuevo __$1__",
  },
  "errors.auth.emailNotVerified": {
    en: "Email is not verified. Please, click on the link we sent to your email (check also your spam inbox)",
    es: "Email no verificado. Por favor haz click en el enlace que hemos enviado a tu email. (Comprueba en Spam)",
  },
  "errors.auth.isGoogleAccount": {
    en: 'You signed in through Google, click on "GOOGLE LOGIN" to login.',
    es: 'Te registraste a través de Google, haz clic en el botón "ENTRA CON GOOGLE" para acceder.',
  },
  "errors.auth.userIsNotRegistered": {
    en: "We couldn't find any user with that e-mail. Please, sign in.",
    es: "No tienes ninguna cuenta. Regístrate.",
  },
  "errors.auth.registeredEmail": {
    en: "You already have an account with this email. Please, log in.",
    es: "Ya tienes una cuenta con este email. Inicia sesión.",
  },
  "errors.contact.alreadyExist": {
    en: "There is already a contact with this email",
    es: "Ya existe un contacto con este email",
  },
  "errors.quotes.codeIsNotUnique": {
    en: "Code already exists.",
    es: "El código ya existe.",
  },
  "errors.invitations.onlyOnceDay": {
    en: "You can only send one invitation to the same email once a day.",
    es: "Sólo puedes reenviar una invitación al mismo email una vez al día.",
  },
};
